import React from 'react'
import { withRouter } from 'react-router'
import SearchUI from '../../../widgets/input/SearchUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import './VendorList.css'

const VendorListUI = ({ context, messageList, vendorList,
  // filters
  searchFilter, onSearchFilterChange,
  // modes
  selectedCount,
  // event handlers
  onRefreshClick, onCreateClick, onUpdateClick, onDeleteClick, onRowClick }) =>
  <div className='c_vndrs'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          messageList={messageList}
          selectedCount={selectedCount}
          onRefreshClick={onRefreshClick}
          onCreateClick={onCreateClick}
          onUpdateClick={onUpdateClick}
          onDeleteClick={onDeleteClick}
        />
      }
      right={
        <ActionTopRightUI
          context={context}
          messageList={messageList}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
        />
      }
    />

    <LRTableBodyUI>
      {
        vendorList.map((vendor, i) =>
          <VendorRowUI key={i} context={context} vendor={vendor}
            messageList={messageList} onRowClick={onRowClick}
          />
        )
      }
    </LRTableBodyUI>
  </div>

const ActionLeftUI = ({ context, messageList, selectedCount, onRefreshClick, onCreateClick, onUpdateClick, onDeleteClick }) =>
  <React.Fragment>
    {
      selectedCount === 0 &&
      <div className='g_flex_h'>
        <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' />
        <IconButtonUI icon='icon-plus' onClick={onCreateClick} label='Add Vendor' />
      </div>
    }
    {
      selectedCount > 0 &&
      <div className='action g_flex_h'>
        {
          selectedCount === 1 &&
          <IconButtonUI messageList={messageList} icon='icon-pencil' onClick={onUpdateClick} labelKey='c_update_vendor' />
        }
        <IconButtonUI messageList={messageList} icon='icon-trash-o' onClick={onDeleteClick} labelKey='c_delete_vendor' />
      </div>
    }
  </React.Fragment>

const ActionTopRightUI = ({ context, messageList, searchFilter, onSearchFilterChange }) =>
  <div className='g_flex_h'>
    <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
  </div>

const VendorRowUI = ({ context, messageList, vendor, onRowClick }) =>
  <LRTableRowUI
    context={context} className='g_flex_top'
    left={<RowLeftUI context={context} vendor={vendor} onRowClick={onRowClick} />}
    right={<RowRightUI vendor={vendor} messageList={messageList} />}
    rowId={vendor.vendorId}
  />

const RowLeftUI = ({ context, vendor, onRowClick }) =>
  <div className='g_flex_h g_flex_top'>
    {/*
      context.permissions.includes('acc_manage') &&
      <input type="checkbox" className='checkbox' checked={vendor.selected} onChange={() => {}} />
    */}
    <div>
      <span>
        {vendor.vendorName}
        {
          vendor.addressList && vendor.addressList.length &&
          <>, {vendor.addressList[0].state}</>
        }
      </span>
      <div className='g_muted g_flex_v'>
        <span>{vendor.contactFullName}</span>
        <span className='g_small'>PAN: {vendor.panNumber}</span>
        <span className='g_small'>GSTN: {vendor.gstin}</span>
        {/*
        <span>{vendor.contactPhone}</span>
        <span>{vendor.contactEmail}</span>
        */}
        {
          vendor.dateCreatedF1 &&
          <span className='g_small'>Created: {vendor.dateCreatedF1}</span>
        }
        {/*<span className='g_tiny'>Updated: {vendor.dateUpdatedF1}</span>*/}
      </div>
    </div>
  </div>

const RowRightUI = ({ vendor, messageList }) =>
  <div className='right g_flex_v'>
    <span>TDS {vendor.tdsSection}
      {vendor.tdsRate ? ` @${vendor.tdsRate}` : ` @0`}%</span>
    <span className='g_muted'>{vendor.tdsNature}</span>
    <span>Bank A/C no: {vendor.bankAccountNumber}</span>
    <span className='g_muted'>IFSC: {vendor.bankIFSCCode}</span>
    <span className='g_muted g_small'>Beneficiary: {vendor.bankBeneficiaryName}</span>
  </div>

export default withRouter(VendorListUI)
